import { create } from "zustand";

export enum ResumesViewMode {
  Grid = "grid",
  List = "list",
}

type ResumesViewStore = {
  resumesViewMode: ResumesViewMode;

  // Actions
  setViewMode: (mode: ResumesViewMode) => void;
};

export const useResumesViewStore = create<ResumesViewStore>(set => ({
  resumesViewMode: ResumesViewMode.Grid,
  setViewMode: (mode) => set({ resumesViewMode: mode }),
}));
